/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Course {
  id: string;
  name: string;
  fullName: string;
  description: string;
  duration: string;
  price: string;
  priceINR: string;
  level: string;
  category: string;
}

export interface CourseCategory {
  title: string;
  description: string;
  gradient: string;
  courses: Course[];
}

export interface CompetencyRank {
  rank: string;
  stMaarten: string;
  guyana: string;
  aruba: string;
  nicaragua: string;
  vietnam: string;
  thailand: string;
}

export interface CadetshipInstallment {
  installment: string;
  duration: string;
  fee: string;
}

export interface CadetshipDetails {
  totalFee: string;
  stipendRange: string;
  duration: string;
  type: string;
}

export interface CadetshipPhase {
  phase: number;
  course: string;
  duration: string;
}

// Competency Training Data
export const competencyData: CompetencyRank[] = [
  {
    rank: "Master/Chief officer",
    stMaarten: "2200",
    guyana: "2200",
    aruba: "2200",
    nicaragua: "2200",
    vietnam: "4400",
    thailand: "4400",
  },
  {
    rank: "2/3 Officer",
    stMaarten: "1800",
    guyana: "1800",
    aruba: "1800",
    nicaragua: "1800",
    vietnam: "3800",
    thailand: "3800",
  },
  {
    rank: "Chief/2 Engineer",
    stMaarten: "1800",
    guyana: "1800",
    aruba: "1800",
    nicaragua: "1800",
    vietnam: "3800",
    thailand: "3800",
  },
  {
    rank: "3/4 Engineer",
    stMaarten: "1500",
    guyana: "1500",
    aruba: "1500",
    nicaragua: "1500",
    vietnam: "3400",
    thailand: "3400",
  },
  {
    rank: "Tanker Endorsement",
    stMaarten: "30",
    guyana: "30",
    aruba: "30",
    nicaragua: "30",
    vietnam: "50",
    thailand: "50",
  },
  {
    rank: "COE",
    stMaarten: "180",
    guyana: "180",
    aruba: "180",
    nicaragua: "180",
    vietnam: "200",
    thailand: "200",
  },
  {
    rank: "CDC",
    stMaarten: "80",
    guyana: "80",
    aruba: "80",
    nicaragua: "80",
    vietnam: "125",
    thailand: "125",
  },
];

export const competencyCountries = [
  { key: "stMaarten", name: "ST. MAARTEN" },
  { key: "guyana", name: "GUYANA" },
  { key: "aruba", name: "ARUBA" },
  { key: "nicaragua", name: "NICARAGUA" },
  { key: "vietnam", name: "VIETNAM" },
  { key: "thailand", name: "THAILAND" },
];

// Cadetship Training Data
export const cadetshipInstallments: CadetshipInstallment[] = [
  {
    installment: "ENROLLMENT FEE",
    duration: "At Enrollment",
    fee: "1050",
  },
  {
    installment: "SECURITY DEPOSIT (Refundable after Onboarding)",
    duration: "At Enrollment",
    fee: "300",
  },
  {
    installment: "1st INSTALLMENT",
    duration: "Before Joining College",
    fee: "2618",
  },
  {
    installment: "2nd INSTALLMENT",
    duration: "After 3 months",
    fee: "3666",
  },
  {
    installment: "3rd INSTALLMENT",
    duration: "After 3 months",
    fee: "3666",
  },
];

export const cadetshipDetails: CadetshipDetails = {
  totalFee: "11300",
  stipendRange: "200 - 300",
  duration: "15 months",
  type: "College and On-Ship Training",
};

export const cadetshipPhases: CadetshipPhase[] = [
  {
    phase: 1,
    course: "SHIP PREPARATORY COURSE",
    duration: "3.5 months",
  },
  {
    phase: 2,
    course: "ONBOARDSHIP (with Stipend)",
    duration: "9 months",
  },
  {
    phase: 3,
    course: "ADVANCE COURSE & CERTIFICATE OF COMPETENCY",
    duration: "2.5 months",
  },
];

// Main Course Categories Data
export const coursesData: Record<string, any> = {
  // "pre-sea-training": {
  //   title: "Pre-Sea Training",
  //   description:
  //     "Entry-level courses required before going onboard for the first time",
  //   gradient: "from-blue-500 to-blue-600",
  //   courses: [
  //     {
  //       id: "btlgtco",
  //       name: "BTLGTCO [GTF]",
  //       fullName: "Basic Training for Liquefied Gas Tanker Cargo Operations",
  //       description:
  //         "Essential training for handling liquefied gas cargo operations on tanker vessels",
  //       duration: "5 days",
  //       price: "$100",
  //       priceINR: "25000",
  //       level: "Beginner",
  //       category: "Gas Tanker",
  //     },
  //     {
  //       id: "btoctco",
  //       name: "BTOCTCO [OTF & CTF]",
  //       fullName: "Basic Training for Oil & Chemical Tanker Cargo Operations",
  //       description:
  //         "Comprehensive training for oil and chemical tanker cargo handling",
  //       duration: "5 days",
  //       price: "$100",
  //       priceINR: "22000",
  //       level: "Beginner",
  //       category: "Tanker Operations",
  //     },
  //     {
  //       id: "psf",
  //       name: "PSF",
  //       fullName: "Personal Survival Techniques",
  //       description: "Essential survival skills for maritime emergencies",
  //       duration: "2 days",
  //       price: "$50",
  //       priceINR: "4000",
  //       level: "Beginner",
  //       category: "Safety",
  //     },
  //     {
  //       id: "stsdsd",
  //       name: "STSDSD",
  //       fullName:
  //         "Security Training for Seafarers with Designated Security Duties",
  //       description:
  //         "Security awareness and procedures for designated personnel",
  //       duration: "2 days",
  //       price: "$50",
  //       priceINR: "6000",
  //       level: "Beginner",
  //       category: "Security",
  //     },
  //     {
  //       id: "basic-stcw-package",
  //       name: "Basic STCW Package",
  //       fullName: "Complete Basic STCW Training Package",
  //       description: "Comprehensive package including all basic STCW courses",
  //       duration: "1 week",
  //       price: "$150",
  //       priceINR: "18000",
  //       level: "Beginner",
  //       category: "Package Deal",
  //     },
  //   ],
  // },
  "stcw-courses": {
    title: "STCW Courses",
    description:
      "Standards of Training, Certification and Watchkeeping courses",
    gradient: "from-teal-500 to-teal-600",
    courses: [
      {
        id: "basic-stcw",
        name: "Basic STCW",
        fullName: "Basic Standards of Training, Certification and Watchkeeping",
        description: "Fundamental STCW training package",
        duration: "1 week",
        price: "$150",
        priceINR: "18000",
        level: "Beginner",
        category: "Basic",
      },
      {
        id: "affa",
        name: "AFFA",
        fullName: "Advanced Fire Fighting",
        description: "Advanced firefighting techniques and leadership",
        duration: "3 days",
        price: "$900",
        priceINR: "12000",
        level: "Advanced",
        category: "Advanced",
      },
      {
        id: "atct",
        name: "ATCT",
        fullName: "Advanced Training for Chemical Tankers",
        description: "Advanced chemical tanker operations",
        duration: "5 days",
        price: "$300",
        priceINR: "28000",
        level: "Advanced",
        category: "Advanced",
      },
      {
        id: "atlg",
        name: "ATLG",
        fullName: "Advanced Training for Liquefied Gas Tankers",
        description: "Advanced gas tanker operations",
        duration: "5 days",
        price: "$300",
        priceINR: "30000",
        level: "Advanced",
        category: "Advanced",
      },
      {
        id: "ato",
        name: "ATO",
        fullName: "Advanced Training for Oil Tankers",
        description: "Advanced oil tanker operations",
        duration: "5 days",
        price: "$300",
        priceINR: "25000",
        level: "Advanced",
        category: "Advanced",
      },
      {
        id: "arpa",
        name: "ARPA",
        fullName: "Automatic Radar Plotting Aid",
        description: "Radar operation and collision avoidance",
        duration: "5 days",
        price: "$300",
        priceINR: "15000",
        level: "Intermediate",
        category: "Simulator",
      },
      {
        id: "ecdis",
        name: "ECDIS",
        fullName: "Electronic Chart Display and Information System",
        description: "Electronic navigation systems training",
        duration: "5 days",
        price: "$450",
        priceINR: "18000",
        level: "Intermediate",
        category: "Simulator",
      },
      {
        id: "gmdss",
        name: "GMDSS",
        fullName: "Global Maritime Distress and Safety System",
        description: "Maritime communication systems",
        duration: "1 week",
        price: "$450",
        priceINR: "20000",
        level: "Intermediate",
        category: "Simulator",
      },
    ],
  },
  "offshore-survival": {
    title: "Offshore & Survival Courses",
    description: "Safety and survival training for offshore operations",
    gradient: "from-red-500 to-red-600",
    courses: [
      {
        id: "bosiet",
        name: "BOSIET",
        fullName: "Basic Offshore Safety Induction and Emergency Training",
        description:
          "Essential offshore safety training with helicopter underwater escape",
        duration: "4 days",
        price: "$450",
        priceINR: "45000",
        level: "Intermediate",
        category: "Offshore Safety",
      },
      {
        id: "h2s",
        name: "H2S",
        fullName: "Hydrogen Sulfide Safety Training",
        description: "Safety training for hydrogen sulfide exposure",
        duration: "1 day",
        price: "$300",
        priceINR: "8000",
        level: "Intermediate",
        category: "Gas Safety",
      },
      {
        id: "hlo",
        name: "HLO",
        fullName: "Helicopter Landing Officer",
        description: "Training for helicopter landing operations",
        duration: "3 days",
        price: "$300",
        priceINR: "25000",
        level: "Advanced",
        category: "Aviation",
      },
      {
        id: "huet",
        name: "HUET",
        fullName: "Helicopter Underwater Escape Training",
        description: "Underwater escape techniques from helicopters",
        duration: "1 day",
        price: "$300",
        priceINR: "15000",
        level: "Intermediate",
        category: "Aviation",
      },
      {
        id: "oertm",
        name: "OERTM",
        fullName: "Offshore Emergency Response Team Member",
        description: "Emergency response training for offshore installations",
        duration: "3 days",
        price: "$300",
        priceINR: "20000",
        level: "Advanced",
        category: "Emergency Response",
      },
      {
        id: "olc",
        name: "OLC",
        fullName: "Offshore Lifeboat Coxswain",
        description: "Lifeboat operation and rescue training",
        duration: "5 days",
        price: "$400",
        priceINR: "30000",
        level: "Advanced",
        category: "Survival",
      },
      {
        id: "survival-basic",
        name: "Basic Survival",
        fullName: "Basic Sea Survival Training",
        description: "Essential sea survival techniques",
        duration: "2 days",
        price: "$150",
        priceINR: "12000",
        level: "Beginner",
        category: "Survival",
      },
      {
        id: "cser",
        name: "CSER",
        fullName: "Confined Space Entry and Rescue",
        description: "Safe entry and rescue procedures for confined spaces",
        duration: "2 days",
        price: "$200",
        priceINR: "18000",
        level: "Advanced",
        category: "Safety",
      },
      {
        id: "foet",
        name: "FOET",
        fullName: "Further Offshore Emergency Training",
        description: "Advanced offshore emergency procedures",
        duration: "2 days",
        price: "$250",
        priceINR: "22000",
        level: "Advanced",
        category: "Emergency Response",
      },
      {
        id: "hda",
        name: "HDA",
        fullName: "Helicopter Deck Assistant",
        description: "Helicopter deck operations and safety",
        duration: "2 days",
        price: "$100",
        priceINR: "15000",
        level: "Intermediate",
        category: "Aviation",
      },
    ],
  },
  "value-added-courses": {
    title: "Value-Added Courses",
    description: "Specialized courses to enhance maritime skills and knowledge",
    gradient: "from-amber-500 to-amber-600",
    courses: [
      {
        id: "maritime-law",
        name: "Maritime Law",
        fullName: "International Maritime Law and Regulations",
        description: "Comprehensive study of maritime legal framework",
        duration: "2 weeks",
        price: "$200",
        priceINR: "35000",
        level: "Advanced",
        category: "Legal",
      },
      {
        id: "port-management",
        name: "Port Management",
        fullName: "Port Operations and Management",
        description: "Port operations, logistics and management principles",
        duration: "3 weeks",
        price: "$350",
        priceINR: "45000",
        level: "Advanced",
        category: "Management",
      },
      {
        id: "ship-management",
        name: "Ship Management",
        fullName: "Ship Management and Operations",
        description: "Comprehensive ship management and business operations",
        duration: "4 weeks",
        price: "$300",
        priceINR: "55000",
        level: "Advanced",
        category: "Management",
      },
      {
        id: "maritime-english",
        name: "Maritime English",
        fullName: "Standard Marine Communication Phrases",
        description: "English communication skills for maritime professionals",
        duration: "1 week",
        price: "$200",
        priceINR: "15000",
        level: "All Levels",
        category: "Communication",
      },
      {
        id: "cargo-handling",
        name: "Cargo Handling",
        fullName: "Advanced Cargo Handling Techniques",
        description: "Specialized cargo handling and stowage procedures",
        duration: "2 weeks",
        price: "$300",
        priceINR: "30000",
        level: "Intermediate",
        category: "Operations",
      },
      {
        id: "maritime-security",
        name: "Maritime Security",
        fullName: "Ship and Port Facility Security",
        description: "ISPS Code implementation and security management",
        duration: "1 week",
        price: "$200",
        priceINR: "20000",
        level: "Intermediate",
        category: "Security",
      },
      {
        id: "environmental-compliance",
        name: "Environmental Compliance",
        fullName: "Maritime Environmental Protection",
        description: "MARPOL and environmental compliance training",
        duration: "1 week",
        price: "$100",
        priceINR: "18000",
        level: "Intermediate",
        category: "Environment",
      },
      {
        id: "leadership-skills",
        name: "Leadership Skills",
        fullName: "Maritime Leadership and Team Management",
        description: "Leadership development for maritime professionals",
        duration: "1 week",
        price: "$200",
        priceINR: "25000",
        level: "Advanced",
        category: "Soft Skills",
      },
    ],
  },
  "competency-training": {
    title: "Competency Training",
    description:
      "Professional maritime competency certifications for career advancement",
    gradient: "from-purple-500 to-purple-600",
    courses: [
      {
        id: "mo",
        name: "Master",
        fullName: "Master/Chief officer",
        description: "Competency certification for Master/Chief officer",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Intermediate",
        category: "Master/Chief officer",
      },
      {
        id: "st-o",
        name: "2/3 Officer",
        fullName: "2/3 Officer",
        description: "Competency certification for 2/3 Officer position",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "2/3 Officer",
      },
      {
        id: "ce",
        name: "Chief",
        fullName: "Chief/2 Engineer",
        description: "Competency certification for Chief/2 Engineer",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "Chief/2 Engineer",
      },
      {
        id: "tf-e",
        name: "3/4 Engineer",
        fullName: "3/4 Engineer",
        description: "Competency certification for 3/4 Engineer",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "3/4 Engineer",
      },
      {
        id: "te",
        name: "Tanker Endorsement",
        fullName: "Tanker Endorsement",
        description: "Competency certification for Tanker Endorsement",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "Tanker Endorsement",
      },
      {
        id: "coe",
        name: "COE",
        fullName: "Certificate of Endorsement",
        description: "Competency certification for COE",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "COE",
      },
      {
        id: "cdc",
        name: "CDC",
        fullName: "Continuous Discharge Certificate",
        description: "Competency certification for CDC",
        duration: "Variable",
        price: "",
        priceINR: "",
        level: "Advanced",
        category: "CDC",
      },
    ],
  },
  // "cadetship-training": {
  //   title: "Cadetship Training",
  //   description:
  //     "Comprehensive maritime cadetship program with college and on-ship training",
  //   gradient: "from-green-500 to-green-600",
  //   courses: [
  //     {
  //       id: "enrollment",
  //       name: "Enrollment",
  //       fullName: "Course",
  //       description: "",
  //       duration: "15 months",
  //       price: "$1350",
  //       priceINR: "",
  //       level: "Entry Level",
  //       category: "Deck",
  //     },
  //     {
  //       id: "deck-cadet",
  //       name: "1st Installment",
  //       fullName: "Course",
  //       description: "",
  //       duration: "3 months",
  //       price: "$2618",
  //       priceINR: "",
  //       level: "Entry Level",
  //       category: "Deck Cadet",
  //     },
  //     {
  //       id: "engine-cadet",
  //       name: "2nd Installment",
  //       fullName: "On Ship",
  //       description: "",
  //       duration: "3 months",
  //       price: "$3666",
  //       priceINR: "",
  //       level: "Entry Level",
  //       category: "Engine Cadet",
  //     },
  //     {
  //       id: "eto-cadet",
  //       name: "3rd Installment",
  //       fullName: "On Ship",
  //       description: "",
  //       duration: "9 months",
  //       price: "$3666",
  //       priceINR: "",
  //       level: "Entry Level",
  //       category: "ETO Cadet",
  //     },
  //   ],
  // },
};

// Helper function to get all courses as a flat array
export const getAllCourses = (): Course[] => {
  return Object.values(coursesData).flatMap((category) => category?.courses);
};

// Helper function to get course by ID
export const getCourseById = (id: string): Course | undefined => {
  return getAllCourses().find((course) => course.id === id);
};

// Helper function to get courses by category
export const getCoursesByCategory = (categoryKey: string): Course[] => {
  return coursesData[categoryKey]?.courses || [];
};
